import { joinClass } from "../../helpers/utils";
import styles from "./index.module.css";

const Button = ({
  children,
  className,
  lightButton,
  isBig,
  paleBlueButton,
  iceBlueButton,
  softBlueButton,
  elipseButton,
  roundedButton,
  coolGreyButton,
  gradientButton,
  transparentGreyButton,
  transparent,
  shadow,
  smallFont,
  onClick,
  disabled,
  styleReverse,
  cancelButton,
  type = "button",
  isLoading,
  fitChild,
  maxRadius,
}) => {
  return (
    <div
      className={joinClass(
        styles["container"],
        fitChild && styles["container_fit-child"]
      )}
    >
      {isLoading && <div className={styles["loader"]} />}
      <button
        className={joinClass(
          styles.button,
          lightButton && styles["button--light"],
          isBig && styles["button-is-big"],
          paleBlueButton && styles["button-pale-blue"],
          iceBlueButton && styles["button-ice-blue"],
          softBlueButton && styles["button-soft-blue"],
          elipseButton && styles["button-elipse"],
          roundedButton && styles["button-rounded"],
          coolGreyButton && styles["button-cool-grey"],
          transparentGreyButton && styles["button-transparent-grey"],
          gradientButton && styles["button--gradient"],
          transparent && styles["button--transparent"],
          shadow && styles["button--shadow"],
          smallFont && styles["button--small-font"],
          styleReverse && styles["button--reverse"],
          cancelButton && styles["button--cancel"],
          maxRadius && styles["button--max_radius"],
          className
        )}
        onClick={onClick}
        disabled={disabled}
        type={type}
      >
        {!isLoading && children}
      </button>
    </div>
  );
};

export default Button;
